__turbopack_context__.v({
  "root": "EmbedSettings-module__4jIaUG__root",
  "snippet": "EmbedSettings-module__4jIaUG__snippet",
});
